import { render } from "./PopUpPreviewQuestion.vue?vue&type=template&id=3910897e"
import script from "./PopUpPreviewQuestion.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__